import axiosInstance from '../utils/api'; // Import the configured axios instance

const API_URL = `/api/notifications`; // Base URL for notification related endpoints

/**
 * Fetches notifications for the current user with pagination.
/**
 * Fetches notifications for the current user with pagination.
 *
 * @param {number} page - The page number to fetch (starting from 1).
 * @param {number} limit - The number of notifications per page.
 * @returns {Promise<object>} - A promise resolving to the notification data.
 */
export const getNotifications = async (page = 1, limit = 10) => {
  try {
    //console.log('API_BASE_URL used in notificationApi:', API_BASE_URL); // Added console log for base URL
    const response = await axiosInstance.get(`${API_URL}?page=${page}&limit=${limit}`);
    //console.log('Data received from backend (notificationApi):', response.data); // Added console log
    return response.data;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error;
  }
};

/**
 * Marks a specific notification as read.
 * @param {string} token - The user's token for authorization.
 * @param {string} notificationId - The ID of the notification to mark as read.
 * @returns {Promise<object>} - A promise resolving to the updated notification data.
 */
export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${notificationId}/read`, {});
    return response.data;
  } catch (error) {
    console.error(`Error marking notification ${notificationId} as read:`, error);
    throw error;
  }
};

/**
 * Marks all notifications for the current user as read.
 * @param {string} token - The user's token for authorization.
 * @returns {Promise<object>} - A promise resolving to the result of the operation.
 */
export const markAllNotificationsAsRead = async () => {
  try {
    const response = await axiosInstance.put(`${API_URL}/mark-all-read`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    throw error;
  }
};

/**
 * Fetches the count of unread notifications for the current user.
 * @param {string} token - The user's token for authorization.
 * @returns {Promise<number>} - A promise resolving to the unread notification count.
 */
export const getUnreadNotificationsCount = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/unread-count`);
    //console.log('notificationApi: Raw response for unread count:', response); // Log the raw response
    //console.log('notificationApi: Data received for unread count:', response.data); // Log the data property
    // Assuming the backend returns { unreadCount: number }
    return response.data.unreadCount;
  } catch (error) {
    console.error('Error fetching unread notifications count:', error);
    throw error;
  }
};

/**
 * Fetches the count of unread Pulse Hub notifications for the current user.
 * @returns {Promise<number>} - A promise resolving to the unread Pulse Hub notification count.
 */
export const getUnreadPulseHubNotificationsCount = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/pulse-hub/unread-count`);
    return response.data.unreadCount;
  } catch (error) {
    console.error('Error fetching unread Pulse Hub notifications count:', error);
    throw error;
  }
};
